'use client';
// This wrapper component ensures RouterSync is only rendered on the client side
import dynamic from 'next/dynamic';

export const RouterSyncClient = dynamic(
  () =>
    import('@/components/router-sync/router-sync').then(
      (mod) => mod.RouterSync
    ),
  { ssr: false }
);
